(function () {
  'use strict';

  if (window.__marlowViewportCompat) return;
  window.__marlowViewportCompat = true;

  var root = document.documentElement;
  var visualViewport = window.visualViewport;
  var frame = 0;
  var stableViewportBaseline = 0;
  var lastVisualViewportHeight = 0;
  var supportsStableViewport = Boolean(
    window.CSS &&
    CSS.supports &&
    CSS.supports('height', '100svh')
  );

  function currentViewportHeight() {
    return Math.max(
      1,
      Math.round(visualViewport ? visualViewport.height : window.innerHeight)
    );
  }

  function activeElementAcceptsText() {
    var active = document.activeElement;
    if (!active) return false;
    return active.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]');
  }

  function updateViewport() {
    frame = 0;
    var height = currentViewportHeight();
    if (height !== lastVisualViewportHeight) {
      lastVisualViewportHeight = height;
      root.style.setProperty('--marlow-visual-viewport-height', height + 'px');
    }

    var coveredHeight = Math.max(
      0,
      Math.max(window.innerHeight, stableViewportBaseline) - height
    );
    var keyboardOpen = activeElementAcceptsText() &&
      coveredHeight > Math.max(120, window.innerHeight * 0.18);
    root.classList.toggle('marlow-keyboard-open', keyboardOpen);
  }

  function scheduleViewportUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateViewport);
  }

  function updateStableFallback() {
    stableViewportBaseline = currentViewportHeight();
    if (!supportsStableViewport) {
      root.style.setProperty('--marlow-stable-viewport-height', stableViewportBaseline + 'px');
    }
    scheduleViewportUpdate();
  }

  var cookieBanner = null;
  var cookieResizeObserver = null;
  var cookieAttributeObserver = null;
  var cookieDiscoveryObserver = null;
  var cookieFrame = 0;
  var cookieSelectors = [
    '#shopify-pc__banner',
    '[data-shopify-privacy-banner]',
    '.shopify-pc__banner__dialog'
  ].join(',');

  function measureCookieBanner() {
    cookieFrame = 0;
    var offset = 0;

    if (cookieBanner && document.contains(cookieBanner)) {
      var style = window.getComputedStyle(cookieBanner);
      var rect = cookieBanner.getBoundingClientRect();
      var visible = style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        parseFloat(style.opacity || '1') > 0 &&
        rect.height > 0;
      var touchesViewportBottom = rect.bottom >= window.innerHeight - 2 ||
        (style.position === 'fixed' && parseFloat(style.bottom || '0') <= 2);

      if (visible && touchesViewportBottom) {
        offset = Math.min(Math.ceil(rect.height), Math.round(currentViewportHeight() * 0.55));
      }
    }

    root.style.setProperty('--marlow-cookie-banner-offset', offset + 'px');
  }

  function scheduleCookieMeasurement() {
    if (cookieFrame) return;
    cookieFrame = window.requestAnimationFrame(measureCookieBanner);
  }

  function observeCookieBanner(banner) {
    cookieBanner = banner;

    if (cookieResizeObserver) cookieResizeObserver.disconnect();
    if (cookieAttributeObserver) cookieAttributeObserver.disconnect();

    if (cookieBanner && window.ResizeObserver) {
      cookieResizeObserver = new ResizeObserver(scheduleCookieMeasurement);
      cookieResizeObserver.observe(cookieBanner);
    }

    if (cookieBanner && window.MutationObserver) {
      cookieAttributeObserver = new MutationObserver(scheduleCookieMeasurement);
      cookieAttributeObserver.observe(cookieBanner, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style']
      });
    }

    scheduleCookieMeasurement();
  }

  function discoverCookieBanner() {
    var banner = document.querySelector(cookieSelectors);
    if (banner !== cookieBanner) observeCookieBanner(banner);
  }

  function cookieMarkupChanged(records) {
    for (var index = 0; index < records.length; index += 1) {
      var record = records[index];
      var nodes = Array.prototype.slice.call(record.addedNodes)
        .concat(Array.prototype.slice.call(record.removedNodes));

      for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
        var node = nodes[nodeIndex];
        if (node.nodeType !== 1) continue;
        if (
          node === cookieBanner ||
          node.matches(cookieSelectors) ||
          node.querySelector(cookieSelectors) ||
          (cookieBanner && node.contains(cookieBanner))
        ) {
          return true;
        }
      }
    }

    return false;
  }

  updateStableFallback();
  discoverCookieBanner();

  window.addEventListener('resize', scheduleViewportUpdate, { passive: true });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(updateStableFallback, 120);
  });
  window.addEventListener('pageshow', function () {
    updateStableFallback();
    discoverCookieBanner();
  });
  document.addEventListener('focusin', scheduleViewportUpdate);
  document.addEventListener('focusout', function () {
    window.setTimeout(scheduleViewportUpdate, 80);
  });

  if (visualViewport) {
    visualViewport.addEventListener('resize', scheduleViewportUpdate, { passive: true });
    visualViewport.addEventListener('scroll', scheduleViewportUpdate, { passive: true });
  }

  if (window.MutationObserver && document.body) {
    cookieDiscoveryObserver = new MutationObserver(function (records) {
      if (cookieMarkupChanged(records)) discoverCookieBanner();
    });
    cookieDiscoveryObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
